<header class="px-24px py-10px absolute left-0 top-0 z-10">
	<a href="/index.html" class="block w-fit" aria-label="BindTuning">
		<img src="./assets/images/bt-logo.svg" width="154" height="32" alt="BindTuning" class="block">
	</a>
</header>
<div class="flex justify-center items-center h-full relative overflow-hidden p-24px">
	<div class="max-w-xl relative z-10 text-center flex flex-col gap-24px items-center justify-center">
		<img src="/assets/images/time.svg" alt="Session expired" width="342" height="202">
		<div>
			<h2 class="text-28 leading-8 font-semibold">You've been logged out.</h2>
			<p class="text-14 leading-4">For your security, you've been automatically logged out due to inactivity.<br>Click below to continue.
			</p>
		</div>
		<button type="button" class="btn-primary" (click)="refresh()">
			I'm still here
		</button>
	</div>
</div>
